import * as React from 'react';
import report from '@jetshop/core/errorReporting';
import styled from 'react-emotion';
const Wrapper = styled('section') `
  width: 57ch;
  max-width: 100%;
  margin: 4rem auto;
  padding: 1rem;
  a {
    display: inline-block;
    margin: 1rem 0 3rem 0;
    border-radius: 3px;
    padding: 0.5rem;
    text-decoration: none;
    font-weight: 600;
    background: #e2e2e2;
    border: 1px solid #c3c3c3;
    color: #000;
    :hover {
      background: #eaeaea;
    }
  }
  h1 {
    font-size: 1.5rem;
    margin-bottom: 2rem;
  }
  pre {
    font-size: 0.875rem;
    line-height: 1.5;
    color: #585858;
  }
`;
const DefaultMessage = ({ error, info }) => (React.createElement(Wrapper, null,
    React.createElement("h1", null, "Something went wrong!"),
    React.createElement("p", null, "Sorry! Our developers have been notified."),
    React.createElement("div", null,
        React.createElement("a", { href: "/" }, "Go back to the start page")),
    React.createElement("div", null,
        error && React.createElement("p", null,
            "Error: ",
            error.message),
        info && React.createElement("pre", null, info.componentStack))));
let ErrorBoundary = /** @class */ (() => {
    class ErrorBoundary extends React.Component {
        constructor() {
            super(...arguments);
            this.state = {
                error: undefined,
                info: undefined
            };
        }
        componentDidCatch(error, info) {
            const { extraInfo = {} } = this.props;
            // Report to Sentry
            report(error, Object.assign(Object.assign({}, extraInfo), { reactInfo: info }));
            this.setState({ error, info });
        }
        render() {
            const Comp = this.props.component;
            if (!this.state.error) {
                return this.props.children;
            }
            return React.createElement(Comp, Object.assign({}, this.state));
        }
    }
    ErrorBoundary.defaultProps = {
        component: DefaultMessage
    };
    return ErrorBoundary;
})();
export default ErrorBoundary;
//# sourceMappingURL=Generic.js.map